import { createContext } from 'react';

import { FLOORPLAN_CONTEXT_DEFAULT } from './constants';
import type { FloorplanContextValue } from './floorplan.type';

export const FloorplanContext = createContext<FloorplanContextValue>(FLOORPLAN_CONTEXT_DEFAULT);
